import { Element, Elements } from 'types';
import elementModel from '../models/element';

export const hasElement = (elements: Elements, id: Element['id']) => elements.hasOwnProperty(id);
export const hasParents = (element: Element) => element.hasOwnProperty('parents')
  && !!element.parents
  && !!element.parents.length;
export const hasTags = (element: Element) => element.hasOwnProperty('tags')
  && !!element.tags
  && !!element.tags.length;

export const prepareElement = (data: any, id: string): Element => {
  /*
  loaded data contains minified properties names:
    - parents -> p
    - name -> n
    - children -> c
  */

  const name = data.name || data.n || '';
  const parents = data.parents || data.p || [];
  const children = data.children || data.c || [];

  delete data.n;
  delete data.c;
  delete data.p;

  return {
    ...elementModel,
    ...data,

    id,
    name,
    children,
    parents,
    final: !children.length,
  };
};
